import { useSelector } from 'react-redux';

// mui
import { Card, CardActions, CardContent, CardHeader, makeStyles, Typography } from '@material-ui/core';
import LaunchIcon from '@material-ui/icons/Launch';
import WarningIcon from '@material-ui/icons/Warning';

// app
import { Button } from 'components';

import { selectUser } from 'stores';
import * as utils from 'utils';

import styles from './RiskIssues.styles';

const RiskIssueCard = ({ title, subtitle, message, url, testid }) => {
  const classes = makeStyles(styles, { name: 'RiskIssueCard' })();

  const user = useSelector(selectUser);
  const isBroker = utils.user.isBroker(user);
  return (
    <Card data-testid={`risk-data-${testid}`} classes={{ root: classes.card }}>
      <CardHeader
        avatar={<WarningIcon fontSize="large" classes={{ root: classes.icon }} />}
        title={
          <Typography variant="h3" className={classes.cardTitle} style={{ textAlign: 'left' }}>
            <Typography className={classes.sectionMessage}>{title}</Typography>
          </Typography>
        }
        subheader={subtitle}
        className={classes.cardHeader}
      />
      <CardContent classes={{ root: classes.cardContent }}>
        <Typography classes={{ root: classes.sectionMessage }}>{message}</Typography>
      </CardContent>
      {url && isBroker ? (
        <CardActions disableSpacing classes={{ root: classes.cardActions }}>
          <Button
            href={url}
            icon={LaunchIcon}
            iconPosition="right"
            rel="noopener"
            target="_blank"
            color="primary"
            size="xsmall"
            text={utils.string.t('risks.issueResolveLink')}
          />
        </CardActions>
      ) : null}
    </Card>
  );
};

const IssueCard = ({ issue, insuredSanctionsCheckResult, reInsuredSanctionsCheckResult, additionalInsuredSanctionsCheckResult }) => {
  const hasInsuredSanctionsCheckResult = insuredSanctionsCheckResult?.id === issue?.entityId;
  const hasReInsuredSanctionsCheckResult = reInsuredSanctionsCheckResult?.id === issue?.entityId;
  const additionalInsuredSanctionsIssue = additionalInsuredSanctionsCheckResult?.find((res) => res?.id === issue?.entityId);

  return (
    <>
      {hasInsuredSanctionsCheckResult && (
        <RiskIssueCard
          title={insuredSanctionsCheckResult.name}
          subtitle={utils.string.t('app.insured')}
          message={insuredSanctionsCheckResult.message}
          url={insuredSanctionsCheckResult.url}
          testid="insured"
        />
      )}
      {hasReInsuredSanctionsCheckResult && (
        <RiskIssueCard
          title={reInsuredSanctionsCheckResult.name}
          subtitle={utils.string.t('app.reInsured')}
          message={reInsuredSanctionsCheckResult.message}
          url={reInsuredSanctionsCheckResult.url}
          testid="reinsured"
        />
      )}
      {additionalInsuredSanctionsIssue && (
        <RiskIssueCard
          title={additionalInsuredSanctionsIssue.name}
          subtitle={utils.string.t('app.additionalInsured')}
          message={additionalInsuredSanctionsIssue.message}
          url={additionalInsuredSanctionsIssue.url}
          testid="additional-insured"
        />
      )}
    </>
  );
};

export default IssueCard;
